export default __webpack_public_path__ + "static/media/github-2-white.73967f8c.svg";